// extracted by mini-css-extract-plugin
module.exports = {"title":"SignUp_title__1___c","Backdrop":"SignUp_Backdrop__3hM4N","titleAccount":"SignUp_titleAccount__3tyuO","input":"SignUp_input__gnveF","button":"SignUp_button__19UTG"};